<template>
  <div class="window-portal-wrapper" :style="{ display: 'none' }">
    <div class="window-portal" v-if="open" ref="portal">
      <v-app>
        <component ref="compInPortal" :is="compName"></component>
      </v-app>
    </div>
  </div>
</template>

<script>
import SummaryReportTable from '../components/SummaryReportTable';
import DetailsTable from '../components/DetailsTable';

function copyStyles(sourceDoc, targetDoc) {
  Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
    try {
      styleSheet.cssRules;
    } catch(e) {
      if (styleSheet.href) {
        // for <link> elements loading CSS from a URL
        const newLinkEl = sourceDoc.createElement('link');

        newLinkEl.rel = 'stylesheet';
        newLinkEl.href = styleSheet.href;
        targetDoc.head.appendChild(newLinkEl);
      }
      return;
    }
    // for <style> elements
    const newStyleEl = targetDoc.createElement('style');

    Array.from(styleSheet.cssRules).forEach(cssRule => {
      // write the text of each rule into the body of the style element
      newStyleEl.appendChild(targetDoc.createTextNode(cssRule.cssText));
    });

    targetDoc.head.appendChild(newStyleEl);
  });
}

export default {
  name: 'window-portal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Table',
    },
    compName: {
      type: String,
      default: '',
    },
    compRef: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      windowRef: null,
      curAppInstance:  null,
      windowOpenFinished: false,
    }
  },
  components: {
    SummaryReportTable,
    DetailsTable,
  },
  watch: {
    open(newOpen) {
      if(newOpen) {
        this.openPortal();
      } else {
        this.closePortal();
      }
    }
  },
  methods: {
    openPortal() {
      const windowH = screen.height;
      const windowW = screen.width;
      this.windowRef = window.open('', '', `width=${windowW},height=${windowH},left=0,top=0`);
      this.windowRef.document.title = this.title;

      copyStyles(this.windowRef.document, this.windowRef.document);
      copyStyles(window.document, this.windowRef.document);

      this.windowRef.addEventListener('beforeunload', this.closePortal);
      this.windowRef.addEventListener('load', this.openTable);
    },
    closePortal() {
      if(this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.$emit('close');
      }
    },
    openTable() {
      this.windowRef.document.body.innerHTML += this.$refs.portal.outerHTML;
      this.windowOpenFinished = true;
    },
  },
  mounted() {
    if (this.open) {
      for (let key of this.compRef._data.copyableDataKeys) {
        this.$refs.compInPortal[key] = this.compRef._data[key];
      }
      this.$refs.compInPortal['isInWindowPortal'] = true;
      this.openPortal();
    }
  },
  beforeUnmount() {
    if (this.windowRef) {
      this.closePortal();
    }
  }
}
</script>

<style lang="scss">

.window-portal .v-application--wrap {
  padding: 10px;
}

.window-portal .v-data-table__wrapper {
    overflow-y: visible;
}

.window-portal #summary-report {
  margin-bottom: 0;
}

</style>





// WEBPACK FOOTER //
// src/components/WindowPortal.vue